import { useQuery } from '@tanstack/react-query';
import { fetch } from 'expo/fetch';

import { SHARED_CACHE_KEYS } from '@/shared/constants/cache';
import { isEmptyOrNull } from '@/shared/utils/string';

export const useFetchHtml = (url?: string | null) =>
  useQuery({
    queryKey: [SHARED_CACHE_KEYS.HTML, { url }],
    queryFn: async () => {
      if (isEmptyOrNull(url)) return '';
      const content = await fetch(url);
      return content.text();
    },
    retry: 2
  });
